import { Paths } from '../../constants/paths';
export const buildCategoryUrl = acCard => {
  const category = acCard.category;
  const params = new URLSearchParams();
  params.set('eco_PRODUCT_TYPE', 'APP'); // categories are app-only
  params.set('eco_CATEGORY', String(category.categories[0]));
  return `${Paths.SEARCH_RESULTS}?${params}`;
};
export const buildCollectionUrl = acCard => {
  var _acCard$collection;
  return Paths.FEATURED_COLLECTION.replace(':collectionSlug', ((_acCard$collection = acCard.collection) === null || _acCard$collection === void 0 ? void 0 : _acCard$collection.slug) || '');
};
export const buildListingUrl = slug => {
  return Paths.LISTING_DETAILS.replace(':listingSlug', slug);
};
export const buildSolutionsPartnerUrl = slug => {
  return Paths.SOLUTIONS_PARTNERS_PARTNER.replace(':profileSlug', slug);
};

/** Used when `Enter` is pressed from the search bar,
 * without clicking an autocomplete item. */
export const buildQuickSearchUrl = search => {
  const searchParams = new URLSearchParams();
  searchParams.set('eco_search', search);
  return `${Paths.SEARCH_RESULTS}?${searchParams}`;
};
export const buildSearchUrl = acCard => {
  const searchParams = new URLSearchParams();
  searchParams.set('eco_search', acCard.term);
  if (acCard.query) searchParams.set('eco_queryType', String(acCard.query.queryType));
  return `${Paths.SEARCH_RESULTS}?${searchParams}`;
};
export const buildCatalogServiceUrl = acCard => {
  var _acCard$catalogServic;
  const searchParams = new URLSearchParams();
  const catalogServiceId = (_acCard$catalogServic = acCard.catalogService) === null || _acCard$catalogServic === void 0 ? void 0 : _acCard$catalogServic.catalogServiceId;
  if (catalogServiceId !== undefined) searchParams.set('eco_PROFILE_CATALOG_SERVICES', String(catalogServiceId));
  return `${Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS}?${searchParams}`;
};